import L from "leaflet";

/**
 * Blindagem do Leaflet contra callbacks que chegam DEPOIS do map.remove().
 *
 * Quando um drawer/modal com mapa fecha no meio de uma animação de zoom
 * (flyTo, fitBounds, duplo clique), o Leaflet ainda dispara
 * `_onZoomTransitionEnd` — só que os panes já foram destruídos e o
 * `_getMapPanePos` estoura com "Cannot read properties of undefined
 * (reading '_leaflet_pos')". Aqui cada ponto crítico simplesmente desiste
 * quando o mapa já não está montado.
 */
const proto = L.Map.prototype;

if (!proto.__autemSafetyPatched) {
  const originalZoomTransitionEnd = proto._onZoomTransitionEnd;
  proto._onZoomTransitionEnd = function patchedZoomTransitionEnd(...args) {
    if (!this._mapPane || !this._container) return undefined;
    return originalZoomTransitionEnd.apply(this, args);
  };

  const originalGetMapPanePos = proto._getMapPanePos;
  proto._getMapPanePos = function patchedGetMapPanePos(...args) {
    if (!this._mapPane) return new L.Point(0, 0);
    return originalGetMapPanePos.apply(this, args);
  };

  const originalMove = proto._move;
  proto._move = function patchedMove(...args) {
    if (!this._mapPane || !this._container) return this;
    return originalMove.apply(this, args);
  };

  const originalRemove = proto.remove;
  proto.remove = function patchedRemove(...args) {
    try {
      this.stop(); // cancela flyTo/panTo/zoom em andamento antes de destruir
    } catch {
      /* mapa já parcialmente destruído */
    }
    return originalRemove.apply(this, args);
  };

  proto.__autemSafetyPatched = true;
}

/**
 * Mesma família de problema, agora no renderizador Canvas (`preferCanvas`
 * do mapa de rota e do replay de trajeto): ao remover o mapa, o Leaflet
 * apaga `_ctx` em `_destroyContainer`. Se um frame de redraw pendente
 * (pan/zoom/fitBounds) ou um update de path chegar depois, `_clear`
 * estoura com "Cannot read properties of undefined (reading 'clearRect')".
 * Renderizador já destruído → simplesmente não redesenha.
 */
if (L.Canvas && !L.Canvas.prototype.__autemSafetyPatched) {
  const canvasProto = L.Canvas.prototype;
  const originalRedraw = canvasProto._redraw;
  canvasProto._redraw = function patchedRedraw(...args) {
    if (!this._ctx || !this._container || !this._map) return undefined;
    return originalRedraw.apply(this, args);
  };
  canvasProto.__autemSafetyPatched = true;
}
